var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoNulo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.04,
    height: 42.048,
    viewBox: "0 0 35.04 42.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete-document_1_",
    "data-name": "delete-document (1)",
    d: "M23.749,0H7.256A5.256,5.256,0,0,0,2,5.256V42.048H37.04V13.291Zm1.027,5.981,6.283,6.283H24.776ZM5.5,38.544V5.256A1.752,1.752,0,0,1,7.256,3.5H21.272V15.768H33.536V38.544ZM26.452,21.824,22,26.28l4.455,4.455-2.477,2.477L19.52,28.757l-4.455,4.455-2.477-2.477,4.455-4.455-4.455-4.455,2.477-2.477L19.52,23.8l4.455-4.455Z",
    transform: "translate(-2)",
    fill: "#d7d7d7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoNulo);
export default __webpack_public_path__ + "static/media/icono-nulo.511df0d024a96b9f3b9611f41f981f5f.svg";
export { ForwardRef as ReactComponent };